"use client";

import type { RewardType, SweepstakeDetails } from "@/app/_lib/apis/sweepstake";
import type { Rarity } from "@/domain/gems-game/domain/lib/Earning";
import { Body, Box, Heading, Stack } from "@biom3/react";
import { List, ListItem, ListItemText } from "@mui/material";
import { RarityText } from "../RarityText";

const rewardNames: Record<RewardType, string> = {
  imx: "IMX",
  point: "Gems",
  free_ticket: "Free entry to following week’s draw",
  ticket_upgrade: "Increase of Reward Tier",
};

export const TierSection = ({
  rarity,
  sweepstake,
}: {
  rarity: Rarity;
  sweepstake?: SweepstakeDetails;
}) => {
  return (
    <Box
      sx={{
        mb: "base.spacing.x8",
        p: "base.spacing.x6",
        bg: "base.color.neutral.600",
        borderRadius: "base.borderRadius.x10",
      }}
    >
      <Heading
        size="medium"
        weight="bold"
        sx={{
          mb: "base.spacing.x4",
        }}
      >
        Prizes available for entries in <RarityText rarity={rarity} /> Tier
      </Heading>

      <Body
        sx={{
          color: "base.color.text.body.primary",
        }}
      >
        This Tier includes the following:
      </Body>
      <Stack gap="base.spacing.x1">
        <Box sx={{ p: "base.spacing.x1", pt: "0" }}>
          <List
            sx={{
              padding: 0,
              listStyleType: "disc",
              paddingLeft: 1.5,
              "& .MuiListItem-root": {
                display: "list-item",
                py: 0,
                paddingLeft: 0.5,
              },
            }}
          >
            {sweepstake?.reward_pool?.[rarity]
              ?.sort()
              .map((reward: RewardType) => (
                <ListItem key={reward}>
                  <ListItemText
                    primary={rewardNames[reward]}
                    sx={{
                      margin: 0,
                      "& .MuiListItemText-primary": {
                        "@media (max-width: 385px)": {
                          fontSize: "0.875rem",
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
          </List>
        </Box>
      </Stack>
    </Box>
  );
};
